import { render, staticRenderFns } from "./MakeNotes.vue?vue&type=template&id=788c7e3e&"
import script from "./MakeNotes.vue?vue&type=script&lang=js&"
export * from "./MakeNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports